/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.ExerciseSubmissionService
 */
import * as References from './ExerciseSubmissionService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.ExerciseSubmissionService#start
 */
export const START_MUTATION_FIELD_NAME = 'com_hubspot_academy_assessments_rpc_ExerciseSubmissionService_start';
export const START_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: START_MUTATION_FIELD_NAME,
  args: ['contentId', 'trackId', 'lessonId', 'playlistId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.startRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.ExerciseSubmissionService#completeExerciseEvents
 */
export const COMPLETE_EXERCISE_EVENTS_MUTATION_FIELD_NAME = 'com_hubspot_academy_assessments_rpc_ExerciseSubmissionService_completeExerciseEvents';
export const COMPLETE_EXERCISE_EVENTS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: COMPLETE_EXERCISE_EVENTS_MUTATION_FIELD_NAME,
  args: ['contentId', 'completedIds', 'trackId', 'playlistId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.completeExerciseEventsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.ExerciseSubmissionService#submit
 */
export const SUBMIT_MUTATION_FIELD_NAME = 'com_hubspot_academy_assessments_rpc_ExerciseSubmissionService_submit';
export const SUBMIT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SUBMIT_MUTATION_FIELD_NAME,
  args: ['contentId', 'trackId', 'lessonId', 'exerciseSubmissionType', 'exerciseSubmissionAsset', 'playlistId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.submitRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});